<template lang="pug">
span
  slot(:url="url")
</template>

<script>
export default {
  name: "BaseUrlProvider",
  props: {
    filepath: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      url: ""
    };
  },
  watch: {
    filepath: {
      handler(n) {
        if (n) this.fetch(this.filepath);
      },
      immediate: true
    }
  },
  methods: {
    async fetch(filepath) {
      const url = await this.$f.storage.ref(filepath).getDownloadURL();
      this.url = url;
    }
  }
};
</script>
